import React from 'react';
import RangeSlider from 'react-range-slider-input';
import 'react-range-slider-input/dist/style.css';
import styles from './RangeSliderFilter.module.css';
import { useSelector, useDispatch } from 'react-redux';
import { setLoudnessFilterMin, setLoudnessFilterMax } from '../redux/slices/loudnessSettingsSlice';

// The slider works in positive 0..RANGE units and maps to -RANGE..0 LUFS.
// RANGE is 70, not 60: ffmpeg's ebur128 reports down to -70 LUFS (its gating
// floor), and real measurements DO land in the -60..-70 band. With the old
// 60 floor those files failed the `loudness >= min` test at EVERY slider
// position — permanently invisible, and (since filters scope the run)
// permanently unmatchable.
const LUFS_RANGE = 70;

const RangeSliderFilter = ({
                               min = 0,
                               max = LUFS_RANGE,
                               step = 0.1,
                           }) => {
    const dispatch = useDispatch();

    // Get values from Redux
    const loudnessFilterMin = useSelector(state => state.loudnessSettings.loudnessFilterMin);
    const loudnessFilterMax = useSelector(state => state.loudnessSettings.loudnessFilterMax);

    const handleChange = (newValue) => {
        const mappedMin = Number((newValue[0] - LUFS_RANGE).toFixed(1));
        const mappedMax = Number((newValue[1] - LUFS_RANGE).toFixed(1));

        dispatch(setLoudnessFilterMin(mappedMin));
        dispatch(setLoudnessFilterMax(mappedMax));
    };

    return (
        <div className={styles.sliderWrapper}>
            <div className={styles.sliderLabel}>
                <span className={styles.labelBlock}>
                    Min: {loudnessFilterMin.toFixed(1)} <span className={styles.unit}>LUFS</span>
                </span>
                &nbsp;&nbsp;
                <span className={styles.labelBlock}>
                    Max: {loudnessFilterMax.toFixed(1)} <span className={styles.unit}>LUFS</span>
                </span>
            </div>

            <RangeSlider
                min={min}
                max={max}
                step={step}
                value={[
                    loudnessFilterMin + LUFS_RANGE,  // maps -70 -> 0
                    loudnessFilterMax + LUFS_RANGE   // maps -70 -> 0
                ]}
                onInput={handleChange}
            />
        </div>
    );
};

export default RangeSliderFilter;
